import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LearningMap = _resolveComponent("LearningMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", null, _toDisplayString(_ctx.$t("stats.student.sidebar.map")), 1),
    _createVNode(_component_LearningMap, {
      class: "mt-4 py-6 shadow bg-white rounded",
      userId: _ctx.studentId,
      courseId: _ctx.courseId,
      type: 'STATS_LEARNING_MAP'
    }, null, 8, ["userId", "courseId"])
  ]))
}